import { render } from "./BulkSetBuyersModal.vue?vue&type=template&id=a174a08a&scoped=true&ts=true&lang=pug"
import script from "./BulkSetBuyersModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BulkSetBuyersModal.vue?vue&type=script&lang=ts&setup=true"

import "./BulkSetBuyersModal.vue?vue&type=style&index=0&id=a174a08a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a174a08a"]])

export default __exports__